// frontend_app/src/lib/sse.js
//
// Minimal Server-Sent Events parser for streams read with fetch(). Unlike
// EventSource, fetch exposes the HTTP status (so 400/401/403 can be reported
// properly), sends our custom header, and can be cancelled with AbortController.

/**
 * Returns a function that accepts text chunks and calls `onEvent({ event, data })`
 * for every complete event. `event` defaults to "message".
 */
export const createSseParser = (onEvent) => {
  let buffer = '';

  const dispatch = (block) => {
    let event = 'message';
    const dataLines = [];
    block.split('\n').forEach((line) => {
      if (!line || line.startsWith(':')) return;
      const colon = line.indexOf(':');
      const field = colon === -1 ? line : line.slice(0, colon);
      let value = colon === -1 ? '' : line.slice(colon + 1);
      if (value.startsWith(' ')) value = value.slice(1);
      if (field === 'event') event = value;
      else if (field === 'data') dataLines.push(value);
    });
    if (dataLines.length || event !== 'message') {
      onEvent({ event, data: dataLines.join('\n') });
    }
  };

  return (chunk) => {
    buffer += chunk.replace(/\r\n?/g, '\n');
    let boundary = buffer.indexOf('\n\n');
    while (boundary !== -1) {
      const block = buffer.slice(0, boundary);
      buffer = buffer.slice(boundary + 2);
      dispatch(block);
      boundary = buffer.indexOf('\n\n');
    }
  };
};

/** Read a fetch Response body as SSE, resolving when the stream ends. */
export const readSseStream = async (response, onEvent) => {
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  const push = createSseParser(onEvent);
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    push(decoder.decode(value, { stream: true }));
  }
  push(decoder.decode());
  push('\n\n');
};
